import styles from "./ValidatedSelect.module.scss";
import Typography from "../Typography/Typography";
import Select from "../Select/Select";

const ValidatedSelect = (props) => {
	const {
		onChange = () => {},
		className,
		center = false,
		placeholder,
		label,
		options = [],
		error = false,
		errorMessage = "",
		setError = () => {},
	} = props;

	return (
		<div className={`${styles.validatedSelectContainer} ${className}`}>
			<Select
				center={center}
				onChange={onChange}
				placeholder={placeholder}
				label={label}
				error={error}
				options={options}
				setError={setError}
			></Select>

			<Typography
				className={styles.validatedSelectErrorMjs}
				color={error ? "primary" : "transparent"}
				variant="p2"
			>
				{errorMessage}
			</Typography>
		</div>
	);
};

export default ValidatedSelect;
